// removed by extract-text-webpack-plugin
module.exports = {"container":"fn4Fzk48mgLtiDJr7gzFN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/SignersByRoles/styles.css
// module id = 2870
// module chunks = 0